import { type MouseEvent, useState } from 'react';

import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { color, Icon, Tag } from '@wf/components';

import styles from './TutorialLink.module.scss';

interface ITutorialLinkProps {
  url: string;
  licenseTypeCode: string;
}

function TutorialLink({ url, licenseTypeCode }: ITutorialLinkProps) {
  const [closed, setClosed] = useState(false);
  const { t } = useTranslation();

  function handleClose(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    setClosed(true);
  }

  function handleOpenUrl() {
    window.open(url, '_blank');
  }

  return (
    <div className={cn(styles.tutorialSection, { [styles.closed as string]: closed })}>
      <button className={styles.button} onClick={handleOpenUrl}>
        <Icon name="ic_play" color={color('indigo')} />
        {t('View Tutorial')}
        <div className={styles.expandableContent}>
          <Tag size="sm" color="typography">
            {`${t('Type')}:`}
            {licenseTypeCode}
          </Tag>
          <Icon name="ic_close" size={16} color={color('typography', 'light')} onClick={handleClose} />
        </div>
      </button>
    </div>
  );
}

export default TutorialLink;
